import React, { FC, Key, useMemo } from 'react';
import styles from './index.module.scss';
import { Spin } from 'antd';
import { getChartOption } from './charts';
import { useRequest } from 'ahooks';
import { apiV2EnergyConservationEnergySavingComparisonPost } from '@maxtropy/dmes-apis-v2';
import dayjs, { Dayjs } from 'dayjs';
import { Empty, useTheme, EchartsWithTheme } from '@maxtropy/components';

export interface IBeforeAndAfterRenovation {
  circuitId?: Key;
  time?: Dayjs;
}

const BeforeAndAfterRenovation: FC<IBeforeAndAfterRenovation> = props => {
  const { circuitId, time } = props;
  const theme = useTheme();

  // 每日改造前后对比
  const { data, loading } = useRequest(
    async () => {
      const res = await apiV2EnergyConservationEnergySavingComparisonPost({
        time: dayjs(time?.format('YYYY-MM')).valueOf(),
        circuitId: circuitId,
      });
      return res;
    },
    {
      ready: !!circuitId && !!time,
      refreshDeps: [circuitId, time],
    }
  );

  const isShowEmpty = useMemo(() => {
    if (data) {
      return false;
    }
    return true;
  }, [data]);

  // 图表
  const chartOption = useMemo(() => getChartOption(data), [data]);

  return (
    <div className={styles.chart_box}>
      {loading ? (
        <Spin spinning={true} className={styles.spin_box} />
      ) : isShowEmpty ? (
        <Empty className={styles.empty_box} />
      ) : (
        <EchartsWithTheme theme={theme} style={{ width: '100%' }} option={chartOption} />
      )}
    </div>
  );
};

export default BeforeAndAfterRenovation;
